/**
 * 共享的纹理背景样式定义
 * 用于提供统一的高级视觉效果
 */

// 优雅的斜线纹理背景样式
export const elegantTextureBackground = {
  backgroundColor: '#fcfcfc',
  backgroundImage: `
    repeating-outline-gradient(
      45deg,
      rgba(220, 220, 220, 0.8),
      rgba(220, 220, 220, 0.8) 3px,
      transparent 3px,
      transparent 10px
    )
  `,
  backgroundSize: '14px 14px',
};

// 带透明度的纹理背景样式（用于预览区域）
export const previewTextureBackground = {
  ...elegantTextureBackground,
  opacity: 0.7,
};
